import type { FaireProductEntity } from "../../entity_types/product";

export const p_ed185j3ebe: FaireProductEntity = {
  token: "p_ed185j3ebe",
  type: "product",
  name: "Magnolia Condolence Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/87e6e929a73ac759e7d98a7ac39f4de1b631a0270e641cd544fbeab18bfe5949/1549395062.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1c37036d999171de6176775760826ff1331f2e7b2a8f0d457d248890dfb17074/1549395079.jpg",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:46.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
